<!-- 录用条件确认书对话框 -->
<template>
    <el-dialog v-model="showDialog" @open="handleOpen" title="个人信息收集告知书"  class="diglog" width="90%"  center :lock-scroll="false"><!-- 子组件维护对话框显隐 -->
        <template #header="{ close, titleId, titleClass }">
            <div class="my-header">
                <h4 :id="titleId" :class="titleClass" style="font-size: 1.5rem; color: #0D2EA0;">个人信息收集告知书</h4>
            </div>
        </template>
        <el-scrollbar height="25rem">
        <div>
            <h3 class="h3Css">
                欢迎您参加兄弟高科技（深圳）有限公司（以下简称“本公司”）的面试。根据《中华人民共和国个人信息保护法》相关规定，在收集个人信息时，必须履行告知义务。请仔细阅读以下内容：						
            </h3>
            <p class="fontCss">入职时您需要填写《员工信息登记表》等表格以及收集个人信息相关资料，这将涉及到您的姓名、出生日期、教育背景、家庭住址、工作经历、电话号码及身份证号码等个人信息。本公司收集与使用您的个人信息，是为了进行必要的人力资源管理。本公司将严格遵守个人信息保护相关政策，尽力保护您的个人信息，不会对外共享、转让和公开披露等。但您已自行公开的信息，或为国家利益、公共利益、司法或行政执法、为了您的重大权益等进行的处理除外。同时您可以按照公司相关流程提出查询、复制、更正或补充您的个人信息。   </p>	
            <p class="fontCss">我已仔细阅读并透彻理解愿意接受和遵守本告知书的全部内容，理解本公司所收集的个人信息均是合理必要的，我保证所提供的个人信息和材料的真实性，我清晰地知道和理解可能产生的风险。</p>	
            	
        </div>
            
        </el-scrollbar>
        <!-- <el-button @click="$emit('confirm','123123')">Confirm</el-button> -->
        <template #footer>
            <span class="dialog-footer">
                <el-button type="primary"  style="float: none; width: 120px;" @click="showDialog = false">
                确定
                </el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script>
 export default {
    data() {
        return {
            showDialog: false,
        }
    },
    methods: {
        show(){
            this.showDialog = true;
            this.$nextTick(()=> {
                // this.$refs.table.query() // el-dialog懒渲染，需要使用nextTick初始化数据
            });
        },
        handleOpen(){ // 由于el-dialog懒渲染，或使用官方提供的open回调
            //this.$refs.table.query() // 这样，第一次打开就能获取到this.$refs.的内容了
        }
    }
}
</script>
<style scoped>
    .fontCss{
        line-height: 1.2rem;
        font-size: 1.2rem;
        padding: 5px 0;
        text-indent:2rem;
    }
    .h3Css{
        line-height: 1.2rem;
        font-size: 1.2rem;
        padding: 5px 0;
        text-indent:2rem;
        font-weight: bold;
    }

</style>